import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=35362de8&scoped=true"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=35362de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35362de8",
  null
  
)

export default component.exports